var loading = {
  state: {
    isLoading: false
  },
  mutations: {
    startLoading: function startLoading(state) {
      state.isLoading = true;
    },
    finishLoading: function finishLoading(state) {
      state.isLoading = false;
    }
  }
};
export default loading;